import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Club } from "../../../../interfaces/club";
import { Staff } from "../../../../interfaces/staff";
import { getStaff } from "../../../../services/staff";
import { ManagementStaffEdit } from "./staff-edit";
import moment from 'moment';
import { getClubOptions } from "../../../../services/club";
import avatar from "../../../../assets/images/avatar.svg";
import { ManagementStaffNew } from "./staff-new";
import { ManagementStaffDelete } from "./staff-delete";
import { AdminStaffTeamSeason } from "./staff-team-season";
import { LoadingSpinner } from "../../../general/loading-spinner";

export function ManagementStaffList() {
    const [staff, setStaff] = useState<Staff[]>([]);
    const [clubOptions, setClubOptions] = useState<any[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showStaffTeamSeason, setShowStaffTeamSeason] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreStaff, setHasMoreStaff] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClub, setSelectedClub] = useState('');
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubOptions(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        getStaff('', '', '', 1, 12)
            .then(response => {
                setStaff(response.data);
                setHasMoreStaff(response.data.length === 12);
                setCurrentPage(1);
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;
        setSearchTerm(s);
        setSelectedClub(club);

        getStaff(s, club, '', 1, 12)
            .then(response => {
                setStaff(response.data);
                setHasMoreStaff(response.data.length === 12);
                setCurrentPage(1);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Staff) => {
        const newStaff = [
            s,
            ...staff
        ];
        setStaff(newStaff);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newStaff = staff.filter((m: Staff) => m.id != id);
        setStaff(newStaff);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedStaff: Staff) => {
        setSelectedId(0);
        const newStaff = staff.map((m: Staff) => {
            if (m.id == changedStaff.id) {
                return changedStaff;
            } else {
                return m;
            }
        });
        setStaff(newStaff);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handleStaffTeamSeason = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowStaffTeamSeason(true);
    }

    const handleStaffTeamSeasonOnSave = (changedStaff: Staff) => {
        setSelectedId(0);
        /*const newStaffs = athletes.map((m: Staff) => {
            if (m.id == changedStaff.id) {
                return changedStaff;
            } else {
                return m;
            }
        });
        setStaffs(newStaffs);*/
        setShowStaffTeamSeason(false);
    }

    const handleStaffTeamSeasonOnClose = () => {
        setSelectedId(0);
        setShowStaffTeamSeason(false);
    }

    const handleLoadMore = () => {
        if (isLoadingMore || !hasMoreStaff) return;

        setIsLoadingMore(true);
        const nextPage = currentPage + 1;

        getStaff(searchTerm, selectedClub, '', nextPage, 12)
            .then(response => {
                setStaff(prevStaff => [...prevStaff, ...response.data]);
                setCurrentPage(nextPage);
                setHasMoreStaff(response.data.length === 12);
                setIsLoadingMore(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoadingMore(false);
            });
    }

    return (
        <div className="staff-list-container">
            <h1>
                { t('Coaches')}
            </h1>
            { !loaded && <LoadingSpinner /> }
            { loaded &&
                <div className="filters-container">
                    <Form onSubmit={ handleSearchSubmit }>
                        <Form.Group className="field-search" controlId="search">
                            <Form.Control type="text" placeholder={ t("Write to search") } />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="club_id">
                            <Form.Select aria-label={ t("club") } name="club">
                                <option value="">{ t("select_club") }</option>
                                { clubOptions.map((c: Club) => {
                                    return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                                })}
                            </Form.Select>
                        </Form.Group>
                        <div className="actions">
                            <Button variant="primary" type="submit">
                                { t("search") }
                            </Button>
                        </div>
                    </Form>
                </div>
            }
            { loaded &&
                <div className="grid-container">
                    <Row>
                        { staff.map((a: Staff) => {
                            return <Col key={ 'staff-' + a.id } xs={12} md={6} lg={4} xl={3}>
                                <div className="staff-card">
                                    <div className="heading">
                                        <div className="avatar">
                                            { a.avatar.length > 0 &&
                                                <img src={ a.avatar[0].url } alt={ a.name } />
                                            }
                                            { a.avatar.length == 0 &&
                                                <img src={ avatar } alt={ a.name } />
                                            }
                                        </div>
                                        <div className="meta">
                                            <div className="name">
                                                { a.name }
                                            </div>
                                            { a.birthdate && (
                                                <div className="years">
                                                    { moment(new Date()).diff(a.birthdate, 'years') + ' ' + t("years").toLowerCase() }
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="actions">
                                        <a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ a.id }>
                                            <i className="bi bi-pencil-square"></i>
                                        </a>
                                        <a href="#" className="icon-link team-season" title={ t("athlete_team_seasons") } onClick={ handleStaffTeamSeason } data-id={ a.id }>
                                            <i className="bi bi-calendar-check"></i>
                                        </a>
                                        <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ a.id }>
                                            <i className="bi bi-trash"></i>
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        })}
                    </Row>
                    { hasMoreStaff && (
                        <Row className="mt-4">
                            <Col className="text-center">
                                <Button
                                    variant="outline-primary"
                                    onClick={handleLoadMore}
                                    disabled={isLoadingMore}
                                >
                                    {isLoadingMore ? t('loading') + '...' : t('Load more')}
                                </Button>
                            </Col>
                        </Row>
                    )}
                </div>
            }
            {/* loaded &&
                <a className="admin-add-new" href="#" onClick={ handleAddNew }>
                    <i className="bi bi-plus-circle"></i>
                </a>
            */}
            { showAddNew &&
                <ManagementStaffNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <ManagementStaffEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showStaffTeamSeason && (selectedId != 0) &&
                <AdminStaffTeamSeason id={ selectedId } onSave={ handleStaffTeamSeasonOnSave } onClose={ handleStaffTeamSeasonOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <ManagementStaffDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
        </div>

    )
}